module.exports = __webpack_public_path__ + "img/good.77ff9258.svg";